module.exports = __webpack_public_path__ + "static/sport/toast-2.e0759b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/toast-2.png
// module id = nSkt
// module chunks = 0